import {
  Box,
  Button,
  Drawer,
  FormControl,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import LanguageIcon from "@mui/icons-material/Language";
import { Link, NavLink } from "react-router-dom";
import RowContainer from "../common/RowContainer";
import { useState } from "react";
import NavigationLink from "./NavigationLink";
import { Typography } from "@mui/material";
import logo from "../../assets/logo1.png";
import { commonRoutes } from "../../utils/routes/Routes";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  selectLanguage,
  setLanguage,
} from "../../redux/features/language/languageSlice";
import LanguageDropdown from "../common/LanguageDropdown";

const WebHeader = () => {
  const theme = useTheme();
  const [openDrawer, setOpenDrawer] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const list = [
    // {
    //   link: "/home",
    //   name: <FormattedMessage id="header.home" />,
    // },
    // {
    //   link: "/about",
    //   name: <FormattedMessage id="header.about" />,
    // },
    // {
    //   link: "/services",
    //   name: <FormattedMessage id="header.services" />,
    // },

    {
      link: commonRoutes.contacts,
      name: <FormattedMessage id="header.contacts" />,
    },
    {
      link: commonRoutes.login,
      name: <FormattedMessage id="header.login" />,
    },
  ];

  const [selectedMenu, setSelectedMenu] = useState(null);

  const DrawerMobileMenu = () => {
    return (
      <Box
        role="presentation"
        onClick={handleDrawerToggle}
        onKeyDown={handleDrawerToggle}
        width={"60vw"}
      >
        <List>
          {list.map((item, index) => {
            return (
              <ListItem
                component={Link}
                to={item.link}
                key={index}
                onClick={() => setSelectedMenu(index)}
              >
                <ListItemText primary={item.name} />
              </ListItem>
            );
          })}
          <div style={{ marginTop: "2rem" }}>
            <LanguageDropdown />
          </div>
        </List>
      </Box>
    );
  };

  return (
    <header>
      <RowContainer align="center">
        <Box
          display={"flex"}
          component={Link}
          to="/"
          title="Revenge"
          width={{ xs: 200, md: 300 }}
        >
          <Box
            component={"img"}
            src={logo}
            alt="Revenge logo"
            height={"50px"}
            width={"150px"}
          />
        </Box>
        {isMobile ? (
          <>
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
            >
              <MenuRoundedIcon />
            </IconButton>
            <Drawer
              anchor="left"
              open={openDrawer}
              onClose={handleDrawerToggle}
            >
              <DrawerMobileMenu />
            </Drawer>
          </>
        ) : (
          <nav>
            <RowContainer style={{ gap: "2rem" }} align="center">
              {list.map((item, index) => {
                return (
                  <RowContainer
                    marginleft={4}
                    key={index}
                    onClick={() => setSelectedMenu(index)}
                  >
                    <NavigationLink
                      to={item.link}
                      index={index}
                      selected={index === selectedMenu}
                    >
                      <Typography
                        color={
                          item.name === "Login"
                            ? theme.palette.primary.main
                            : theme.palette.text.primary
                        }
                        variant="h3"
                        fontSize="16px"
                      >
                        {item.name}
                      </Typography>
                    </NavigationLink>
                  </RowContainer>
                );
              })}
              <LanguageDropdown />
            </RowContainer>
          </nav>
        )}
      </RowContainer>
    </header>
  );
};
export default WebHeader;
